import { useSearchParams } from "react-router-dom";
import { stringToBoolean, safeJsonParse } from "../index";
import { FOOTER_TYPES } from "../../constants";
import { getSvgComponent } from "../svgUtils";
import {
  CustomButton,
  MeatBallsLoader,
  ResendOTP,
  AcceptOurTC,
  IconText,
  CheckBox,
  PoweredByLogo,
  SkipButton,
  PaginationDot,
  LinkText,
  AcceptOurConsent,
} from "../../components";

const redirectToApp = (props) => {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (/android/i.test(userAgent)) {
    window.location.href = "instagram://stories";
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    window.location.href = "instagram://stories";
  } else {
    window.location.href = JSON.parse(props?.url)?.value;
  }
};

// footer component mapping
export const FOOTER_COMPONENT_MAPPING = {
  [FOOTER_TYPES.DEFAULT_BUTTON]: (props) => {
    const [searchParams] = useSearchParams();
    const intentId = searchParams.get("intentId");
    const status = searchParams.get("status");
    const tenant = searchParams.get("tenant");
    const isUrlButton =
      props?.url && JSON.parse(props?.url)?.value && !intentId && !status;

    return isUrlButton ? (
      <a
        className="button-wrapper"
        onClick={() => (tenant === "daem" ? redirectToApp(props) : null)}
        href={tenant === "daem" ? "#" : JSON.parse(props?.url)?.value}
      >
        <CustomButton
          {...props}
          buttonText={intentId ? "Next" : props.buttonText}
        />
      </a>
    ) : (
      <CustomButton {...props} />
    );
  },
  [FOOTER_TYPES.MEAT_BALLS_LOADER]: (props) => <MeatBallsLoader {...props} />,
  [FOOTER_TYPES.RESEND_OTP]: (props) => <ResendOTP {...props} />,
  [FOOTER_TYPES.ACCEPT_OUR_TC]: (props) => <AcceptOurTC {...props} />,
  [FOOTER_TYPES.ICON_TEXT]: (props) => <IconText {...props} />,
  [FOOTER_TYPES.CHECK_BOX_PERMISSION]: (props) => <CheckBox {...props} />,
  [FOOTER_TYPES.POWERED_BY]: (props) => <PoweredByLogo {...props} />,
  [FOOTER_TYPES.SKIP_BUTTON]: (props) => <SkipButton {...props} />,
  [FOOTER_TYPES.PAGINATION_DOT]: (props) => <PaginationDot {...props} />,
  [FOOTER_TYPES.LINK_TEXT]: (props) => <LinkText {...props} />,
  [FOOTER_TYPES.ACCEPT_OUR_CONSENT]: (props) => <AcceptOurConsent {...props} />,
};

export const footerSchema = (components, mapping) => {
  return components
    .map((item) => {
      switch (item.attributes.type) {
        case FOOTER_TYPES.DEFAULT_BUTTON:
          return {
            Component: mapping[FOOTER_TYPES.DEFAULT_BUTTON],
            props: {
              type: FOOTER_TYPES.DEFAULT_BUTTON,
              buttonText: item.attributes.buttonText,
              action: item?.attributes.action,
              url: item?.attributes?.url,
              isCheckBox: item?.attributes?.is_check_box,
              checkBoxLabel: item?.attributes?.check_box_label,
              isPoweredByLogoVisible: item?.attributes?.is_powered_by_logo,
              showProviderName: item?.attributes?.showProviderName,
              btnVariant: item?.attributes?.btnVariant,
              containerClassName: item?.attributes?.containerClassName,
              showBackConfirm: item?.attributes?.showBackConfirm,
              navigateTo: item?.attributes?.navigateTo,
              isFileUpload: item?.attributes?.isFileUpload,
              removeDisplayFlex: item?.attributes?.removeDisplayFlex,
              navigateToBack: item?.attributes?.navigateToBack,
              expiresIn: item?.attributes?.expiryDate,
              leftIcon: getSvgComponent(item?.attributes?.leftIcon),
              rightIcon: getSvgComponent(item?.attributes?.rightIcon),
              buttonWrapperClass: item?.attributes?.buttonWrapperClass,
              buttonType: item?.attributes?.buttonType
                ? item?.attributes?.buttonType
                : "default",
              style: {
                maxWidth: item?.attributes?.maxWidth
                  ? item?.attributes?.maxWidth
                  : "90",
              },
              isEditMyRevenue: stringToBoolean(
                item?.attributes?.isEditMyRevenue
              ),
            },
          };
        case FOOTER_TYPES.MEAT_BALLS_LOADER:
          return {
            Component: mapping[FOOTER_TYPES.MEAT_BALLS_LOADER],
            props: {
              type: FOOTER_TYPES.MEAT_BALLS_LOADER,
              loadingText: item.attributes.loadingText,
              style: {
                marginTop: item?.attributes?.marginTop,
              },
            },
          };
        case FOOTER_TYPES.RESEND_OTP:
          return {
            Component: mapping[FOOTER_TYPES.RESEND_OTP],
            props: {
              type: FOOTER_TYPES.RESEND_OTP,
            },
          };
        case FOOTER_TYPES.ACCEPT_OUR_TC:
          return {
            Component: mapping[FOOTER_TYPES.ACCEPT_OUR_TC],
            props: {
              type: FOOTER_TYPES.ACCEPT_OUR_TC,
              acceptText: item?.attributes?.acceptText,
              termsAndConditionText: item?.attributes?.termsAndConditionText,
              acceptEndText: item?.attributes?.acceptEndText,
              isCheckBoxHide: item?.attributes?.isCheckBoxHide,
              privacyText: item?.attributes?.privacyText,
              isModalView: stringToBoolean(item?.attributes?.isModalView),
              termsConditionsContent: safeJsonParse(
                item?.attributes?.termsConditionsContent,
                null
              ),
              privacyPolicyContent: safeJsonParse(
                item?.attributes?.privacyPolicyContent,
                null
              ),
            },
          };
        case FOOTER_TYPES.ICON_TEXT: {
          return {
            Component: mapping[FOOTER_TYPES.ICON_TEXT],
            props: {
              icon: getSvgComponent(item?.attributes?.icon),
              text: item?.attributes?.text,
              type: FOOTER_TYPES.ICON_TEXT,
            },
          };
        }
        case FOOTER_TYPES.CHECK_BOX_PERMISSION: {
          return {
            Component: mapping[FOOTER_TYPES.CHECK_BOX_PERMISSION],
            props: {
              type: FOOTER_TYPES.CHECK_BOX_PERMISSION,
              label: item?.attributes?.label,
            },
          };
        }
        case FOOTER_TYPES.POWERED_BY: {
          return {
            Component: mapping[FOOTER_TYPES.POWERED_BY],
            props: {
              type: FOOTER_TYPES.POWERED_BY,
              title: item?.attributes?.title,
              footerText: item?.attributes?.footerText,
              isHidePoweredBy: item?.attributes?.isHidePoweredBy,
            },
          };
        }
        case FOOTER_TYPES.SKIP_BUTTON: {
          return {
            Component: mapping[FOOTER_TYPES.SKIP_BUTTON],
            props: {
              type: FOOTER_TYPES.SKIP_BUTTON,
              buttonText: item?.attributes?.buttonText,
            },
          };
        }
        case FOOTER_TYPES.PAGINATION_DOT:
          return {
            Component: mapping[FOOTER_TYPES.PAGINATION_DOT],
            props: {
              type: FOOTER_TYPES.PAGINATION_DOT,
              paginationIndex: item?.attributes?.paginationIndex,
              numberOfDots: item?.attributes?.numberOfDots,
            },
          };
        case FOOTER_TYPES.LINK_TEXT:
          return {
            Component: mapping[FOOTER_TYPES.LINK_TEXT],
            props: {
              type: FOOTER_TYPES.LINK_TEXT,
              labelText: item?.attributes?.labelText,
              linkText: item?.attributes?.linkText,
              action: item?.attributes?.action,
              mailTo: item?.attributes?.mailTo,
              navigateTo: item?.attributes?.navigateTo,
              linkTextStyle: safeJsonParse(item?.attributes?.linkTextStyle, {}),
              containerStyle: safeJsonParse(
                item?.attributes?.containerStyle,
                {}
              ),
              labelTextStyle: safeJsonParse(
                item?.attributes?.labelTextStyle,
                {}
              ),
            },
          };
        case FOOTER_TYPES.ACCEPT_OUR_CONSENT:
          return {
            Component: mapping[FOOTER_TYPES.ACCEPT_OUR_CONSENT],
            props: {
              type: FOOTER_TYPES.ACCEPT_OUR_CONSENT,
              data: item?.attributes?.data,
            },
          };
        default:
          return null;
      }
    })
    .filter(Boolean);
};
